/**
 * GraphQL mutation for creating an ABR filter.
 */

import { gql } from '@apollo/client';

export const CREATE_ABR_FILTER = gql`
  mutation CreateAbrFilter($input: CreateAbrFilterInput!) {
    createAbrFilter(input: $input) {
      id
      communityId
      name
      description
      criteria {
        reportedContent
        textLabelFilters {
          labelId
          contentType
          minSeverity
          minScore
        }
        textLabelFilterModifier
        imageLabelFilters {
          labelId
          contentType
          minSeverity
          minScore
        }
        imageLabelFilterModifier
      }
      createdAt
      createdBy
    }
  }
`;
